/**
 * Created by tendlich
 *
 * model for a row in the grid view
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/extendedList/ticketsGridRowView.tmpl"),
        TicketModel = require("connection-models/ticketTab/TicketModel"),
        TicketsGridRowView = {};

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketsGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "ticket-row",
            template: template,
            model: TicketModel,
            ui: {
                selector: ".selector",
                name: ".name",
                description: ".description"
            },
            events: {
                "click": "_onRowClick"
            },

            initialize: function() {
                this.ticketTabChannel =  LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_TAB);
            },

            _onRowClick: function() {
                this.ticketTabChannel.vent.trigger("TicketTabController::ticket:display", {model:this.model, fromExtendedView: true});
            },

            onRender: function(){
                if(!this.model.id){
                   this._hide();
                }
            },

            _hide: function(){
                this.$el.addClass("hide");
            }

        });
    });

    return TicketsGridRowView;
});
